import * as types from './types'
import storage from '@/plugins/storage'
var zeus = {
  get init() {
    let lookups = []
    if (storage.local.getItem(types.SESSION_CANCELREASONS)) {
      lookups['workorder.cancelreason'] = JSON.parse(storage.local.getItem(types.SESSION_CANCELREASONS))
    }
    if (storage.local.getItem(types.SESSION_WORKORDERSTATUS)) {
      lookups['workorder.status'] = JSON.parse(storage.local.getItem(types.SESSION_WORKORDERSTATUS))
    }
    if (storage.local.getItem(types.SESSION_DISPATCHSTATUS)) {
      lookups['dispatch.status'] = JSON.parse(storage.local.getItem(types.SESSION_DISPATCHSTATUS))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATEREASONS)) {
      lookups['workorder.calibratereason'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATEREASONS))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATESYSTEMS)) {
      lookups['workorder.calibratesystem'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATESYSTEMS))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATEFIXTURES)) {
      lookups['workorder.calibratefixture'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATEFIXTURES))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATEIMAGES)) {
      lookups['workorder.calibrateimage'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATEIMAGES))
    }
    if (storage.local.getItem(types.SESSION_CALIBRATENOTES)) {
      lookups['workorder.calibratenote'] = JSON.parse(storage.local.getItem(types.SESSION_CALIBRATENOTES))
    }
    if (storage.local.getItem(types.SESSION_VOIDREASONS)) {
      lookups['workorder.voidreason'] = JSON.parse(storage.local.getItem(types.SESSION_VOIDREASONS))
    }
    if (storage.local.getItem(types.SESSION_MOBILEHANDOFF)) {
      lookups['mobile.handoff'] = JSON.parse(storage.local.getItem(types.SESSION_MOBILEHANDOFF))
    }
    if (storage.local.getItem(types.SESSION_APPLAYERPROTOCOL)) {
      lookups['device.applayerprotocol'] = JSON.parse(storage.local.getItem(types.SESSION_APPLAYERPROTOCOL))
    }
    if (storage.local.getItem(types.SESSION_APPINTERFACE)) {
      lookups['device.appinterface'] = JSON.parse(storage.local.getItem(types.SESSION_APPINTERFACE))
    }
    if (storage.local.getItem(types.SESSION_WORKORDERSERVICETYPE)) {
      lookups['workorder.servicetype'] = JSON.parse(storage.local.getItem(types.SESSION_WORKORDERSERVICETYPE))
    }
    if (storage.local.getItem(types.SESSION_ISSUECATEGORY)) {
      lookups['issue.category'] = JSON.parse(storage.local.getItem(types.SESSION_ISSUECATEGORY))
    }
    if (storage.local.getItem(types.SESSION_ISSUECOMMON)) {
      lookups['issue.common'] = JSON.parse(storage.local.getItem(types.SESSION_ISSUECOMMON))
    }
    return lookups
  }
}
export default {
  lookups: {},
  lookupsZeus: zeus.init || [],
  groups: [],
  timeZones: JSON.parse(storage.local.getItem(types.SESSION_TIMEZONES)) || [],
  insuranceCompanies: JSON.parse(storage.local.getItem(types.SESSION_INSURANCECOMPANIES)) || [],
  vehicleMakes: JSON.parse(storage.local.getItem(types.SESSION_VEHICLEMAKES)) || [],
  odometerunits: JSON.parse(storage.local.getItem(types.SESSION_ODOMETERUNITS)) || [],
  damagepositions: JSON.parse(storage.local.getItem(types.SESSION_DAMAGEPOSITIONS)) || []
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/state.js